import { useQuery } from '@hooks/reactQuery';

import { getKpiVendors } from '@api/kpi';

import { extractQueryParams } from '@utils/common';

import { DefaultVendorOptions } from '@interfaces/alarms/threshold';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { VENDORS_KPI } from '@constants/queryKeys';

export const useQueryKpiVendors = (isKpiView: boolean) => {
	const {
		data: optionsVendorsKpi,
		isLoading: isLoadingVendorsKpi,
	} = useQuery({
		queryKey: [VENDORS_KPI],
		queryFn: extractQueryParams(getKpiVendors),
		allowedRoles: [
			EUserRoles.networkOperatorKpiViewer,
			EUserRoles.networkOperatorKpiUpdater,
		],
		select: (vendors: Array<DefaultVendorOptions>) => vendors.map(item => ({
			isDefault: item.isDefault,
			label: item.vendor.title,
			value: item.vendor.name,
		})).sort((a, b) => {
			const firstName = a.label.toLowerCase();
			const secondName = b.label.toLowerCase();

			if (firstName < secondName) return -1;

			if (firstName > secondName) return 1;

			return 0;
		}),
		enabled: [isKpiView],
		...refetchOptions,
	});

	return {
		optionsVendorsKpi,
		isLoadingVendorsKpi,
	};
};
